// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Rh+-N","btn_submit":"Form_btn_submit__XXtik","afterMessage":"Form_afterMessage__4DA5k"};